import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IPersistState {
  failledPlansRapport: IPlanItem[];
}

export interface IPlanItem {
  index: number;
  title: string;
  name: string;
  type: ITypePlanRapportItem;
  content: string;
  instructions: string;
  typographie: ITypographie;
}

export type ITypePlanRapportItem = "textarea" | "p" | "array" | "";

export type ITypographie =
  | "h5"
  | "h6"
  | "subtitle1"
  | "subtitle2"
  | "caption"
  | "body1"
  | "body2"
  | ""
  | undefined;

const initialState: IPersistState = {
  failledPlansRapport: [],
};

export const persisteSlice: any = createSlice({
  name: "persiste",
  initialState: initialState,
  reducers: {
    setFailledPlansRapport: (state, action: PayloadAction<IPlanItem[]>) => {
      state.failledPlansRapport = action.payload;
    },
  },
});

export const { setFailledPlansRapport } = persisteSlice.actions;

export default persisteSlice.reducer;
